import { withStyles } from '@material-ui/core/styles';


// Styles for GroupCellRenderer component
export const groupCellRendererStyles = (theme) => {
  // Safe spacing function with fallback
  const spacing = (value) => {
    if (typeof theme.spacing === 'function') {
      return theme.spacing(value);
    }
    // Fallback to pixel values
    return `${value * 8}px`;
  };

  return {
    expandButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      padding: `${spacing(0.5)} ${spacing(1)}`,
      borderRadius: theme.shape?.borderRadius || 4,
      transition: theme.transitions?.create ? 
        theme.transitions.create(['background-color', 'color'], {
          duration: theme.transitions.duration.short,
        }) : 'background-color 0.2s ease, color 0.2s ease',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      color: theme.gridTextColor,
      '& svg': {
        fontSize: '26px', // Increased icon size
        width: '26px',
        height: '26px',
        transition: 'transform 0.2s ease',
      },
      '&:active svg': {
        transform: 'scale(0.95)', // Slight scale effect on click
      },
    },
    
    shipperNameContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    
    groupCount: {
      fontWeight: theme.typography?.fontWeightMedium || 500,
      marginRight: spacing(0.5),
    },
  };
};


export const StyledGroupCellRenderer = withStyles(groupCellRendererStyles);
